"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPreviewProduct = void 0;
var _fetching = require("@ori/fetching");
var _concept = require("./concept");
const searchPreviewProduct = exports.searchPreviewProduct = (0, _fetching.gql)`
  ${_concept.conceptFragment}
  fragment SearchPreviewProduct on Product {
    productCode
    imageUrl
    conceptCode
    labels {
      ...ProductLabels
    }
    pdpUrl {
      relativeUrl
    }
    price {
      price {
        priceAfterImmediateDiscount
        currentPrice
      }
    }
    formattedPrice {
      price {
        basicCataloguePrice
        currentPrice
        priceAfterImmediateDiscount
      }
    }
    concept {
      ...BaseConcept
    }
    subscription {
      available
    }
  }
`;